import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { BiArrowBack } from "@react-icons/all-files/bi/BiArrowBack";
import "./style.scss";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";

const getClassNames = ({
  isActive, completedSteps, path, isPaymentStep,
}) => {
  const isCompleted = completedSteps.includes(path);

  return [
    isActive && "active",
    !isActive && isCompleted && "complete",
    isPaymentStep && "no-hover",
  ]
    .filter(Boolean)
    .join(" ");
};

const StepsProgressIndicator = ({
  routes, completedSteps, currentStep, setNextStep, handleNavigateBack,
}) => {
  const { translate: t } = useLanguageProvider();

  const handleBack = () => {
    const currStepInd = routes.findIndex((route) => route.step.path === currentStep[0]?.path);
    if (currStepInd > 0) {
      const prevPath = routes[currStepInd - 1]?.step?.path;
      handleNavigateBack(prevPath);
    }
  };
  return (
    <div className="steps-progress-indicator">
      <ul className="steps-progress-indicator__list">
        {routes.map((route, i) =>
          (route.step.path ? (
            <li key={route.step.name ?? route.step.path}>
              {![0, routes.length - 1].includes(i) && (
                <button
                  className="steps-progress-indicator__mobile-back-btn"
                  onClick={handleBack}
                >
                  <BiArrowBack size={20} />
                </button>
              )}
              <NavLink
                to={route.step.path}
                className={getClassNames({
                  isActive: currentStep[0]?.path === route.step.path,
                  completedSteps,
                  path: route.step.path,
                  isPaymentStep: currentStep[0]?.path.includes("payment"),
                })}
                onClick={(e) => {
                  // prevent navigation if not completedStep or already on payments page
                  if (
                    !completedSteps.includes(route.step.path)
                    || currentStep[0]?.path.includes("payment")
                  ) {
                    e.preventDefault();
                  } else {
                    setNextStep(route.step.path);
                  }
                }}
              >
                <span className="steps-progress-indicator__title">
                  {t(route.step.name) ?? route.step.url}
                </span>
                <span className="steps-progress-indicator__number">{i + 1}</span>
              </NavLink>
            </li>
          ) : null))}
      </ul>
    </div>
  );
};
StepsProgressIndicator.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      step: PropTypes.shape({
        path: PropTypes.string.isRequired,
      }).isRequired,
      bodyCopy: PropTypes.object,
    }).isRequired,
  ).isRequired,
  completedSteps: PropTypes.array.isRequired,
};

export default StepsProgressIndicator;
